<template>
  <div class="shortcuts-container">
    <div
      v-if="shortcuts.length > 0"
      class="shortcuts-module">
      <ul class="shortcuts">
        <li
          v-for="(el, idx) of shortcuts"
          :id="`to-${el.id}`"
          :key="`shortcut-${idx}`"
          class="shortcut"
          @click="scrollTo(el.id)">
          <span class="shortcut-title">
            {{ el.title }}
          </span>
          <div class="shortcut-idx-wrapper">
            <span>0{{ idx + 1 }}</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup>
import { onBeforeUnmount, onMounted, onUpdated, ref } from 'vue'
import useSmoothScroll from '@/components/composables/useSmoothScroll.js'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)
import useUtils from '@/components/composables/useUtils.js'
import useModulesReady from '@/components/composables/useModulesReady.js'

const counter = ref(0)

const { modulesLoading } = useModulesReady()

const { locoScroll } = useSmoothScroll()
const { genUUID } = useUtils()

const animID = ref({
  intro: `anim-${genUUID()}`,
  onScroll: `anim-${genUUID()}`,
})

const shortcuts = ref([])

const getAnchors = () => {
  const anchors = Array.from(document.querySelectorAll('.menu-anchor'))
  if (anchors.length === 0 && counter.value < 10) {
    setTimeout(() => {
      getAnchors()
      counter.value = counter.value + 1
    }, 100)
  } else {
    shortcuts.value = anchors.map((anchor) => {
      return {
        id: anchor.id,
        title: anchor.textContent,
        html: anchor,
      }
    })
  }
}

const introAnim = () => {
  const tl = gsap
    .timeline
    //  {
    //   scrollTrigger: {
    //     trigger: document.body,
    //     start: 'top top',
    //     end: 'top+=200 top',
    //     id: animID.value.intro,
    //     scrub: true,
    //   },
    // }
    ()

  tl.to('.shortcuts-module', {
    width: '40px',
    borderRadius: '20%/50%',
  }).to(
    '.shortcuts',
    {
      paddingRight: '9px',
    },
    '<'
  )
  // .to(
  //   '.shortcut-title, .shortcut-idx-wrapper > span',
  //   {
  //     opacity: '0.25',
  //   },
  //   '<'
  // )
}

const waitForHeroAndIntro = () => {
  gsap.fromTo(
    '.shortcuts-module',
    {
      opacity: 0,
      width: '40px',
    },
    {
      opacity: 1,
      duration: 0.5,
      width: '250px',
      delay: 4,
    }
  )
}

const animateIn = () => {
  gsap.set('.shortcuts-module', {
    opacity: 0,
  })
  if (modulesLoading.value) {
    setTimeout(() => {
      animateIn()
    }, 100)
  } else {
    introAnim()
    // onScrollAnim()
    waitForHeroAndIntro()
  }
}

// const onScrollAnim = () => {
//   shortcuts.value.forEach((shortcut) => {
//     gsap.to(`#to-${shortcut.id} > .shortcut-idx-wrapper > span`, {
//       background: '#FFEF00',
//       width: '35px',
//       height: '35px',
//       opacity: '1',
//       scrollTrigger: {
//         trigger: shortcut.html,
//         scrub: true,
//         id: animID.value.onScroll,
//       },
//     })
//   })
// }

const fadeOut = () => {
  gsap.to('.shortcuts-container', {
    opacity: 0,
    duration: 0.5,
    scrollTrigger: {
      trigger: '.site-footer',
      start: 'top-=400 center',
      end: 'top-=100 center',
      scrub: true,
      markers: false,
    },
  })
}

const scrollTo = (id) => {
  locoScroll.value.scrollTo(document.querySelector(`#${id}`))
}

onMounted(() => {
  getAnchors()
  fadeOut()
})
onUpdated(() => {
  animateIn()
})

onBeforeUnmount(() => {
  const intro = ScrollTrigger.getById(animID.value.intro)
  if (intro) intro.kill()
  const onScroll = ScrollTrigger.getById(animID.value.onScroll)
  if (onScroll) onScroll.kill()
})
</script>

<style lang="scss" coped>
.shortcuts-container {
  @apply pointer-events-none z-9 absolute top-0 left-0 w-full h-[100vh] pr-[20px]
  flex justify-end items-start pt-[30%] lg:pt-0 lg:items-center
  lg:pr-[60px];
  .shortcuts-module {
    @apply pointer-events-auto bg-white text-[#353841] rounded-3xl
      flex flex-col items-end
     overflow-hidden;
    .shortcuts {
      @apply flex flex-col gap-[33px] w-[250px] px-[15px] py-[30px];
      .shortcut {
        @apply cursor-pointer relative flex justify-end items-center gap-[13px];

        &-title {
          @apply absolute right-[47px] text-[1.6rem] text-right;
          @include font-main-med;
        }

        &-idx-wrapper {
          background-image: url('@/assets/img/shortcut-circle.svg');
          background-repeat: no-repeat;
          background-size: contain;
          @apply relative w-[35px] h-[35px];
          span {
            @apply absolute w-[25px] h-[25px]
            flex items-center justify-center  text-[#010B1C] text-[1.4rem] font-normal leading-[14px] text-center;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            transition: all ease-in-out;
            @include font-main-med;
          }
        }

        &::after {
          @apply absolute w-[1px] h-[15px] bg-[#BABBBB] right-[17px] top-[calc(100%_+_9px)];
          content: '';
        }
        &:last-child::after {
          opacity: 0;
        }
      }
    }
  }
}
// 20 + 40
// 20
</style>
